import React, { Component } from 'react';
import { setState } from './lib/state'
import { updatePath } from './lib/path'
import t from './translate/t'
import _ from 'lodash'

const districts = require('./data/districts')
const districtNames = Object.keys(districts).sort()

const rawCounties = []

for (const key in districts) {
  const district = districts[key]
  for (const county of district.counties) {
    rawCounties.push({ name: county, districtId: district.id })
  }
}

const sortedCounties = _.sortBy(rawCounties, '0')

function setDistrict(district) {
  setState({ district })
  updatePath()

  window.scrollTo(0, 0)
}

class CountySearch extends Component {
  state = {
    input: '',
    open: false,
    counties: []
  }

  onInputChange(event) {
    const input = event.target.value
    const counties = _.take(sortedCounties.filter(({ name }) => input && name.toLowerCase().startsWith(input.toLowerCase())), 8)

    this.setState({ input, open: true, counties })
  }

  onSubmit(event) {
    event.preventDefault()

    const { counties } = this.state

    if (counties.length === 1) {
      setDistrict(counties[0].districtId)
    }
  }

  onBlur() {
    if (this.state.input.length === 0) {
      this.setState({ open: false })
    }
  }

  render() {
    const { input, open, counties } = this.state

    return <form className="pt-8 text-center" onSubmit={event => this.onSubmit(event)}>
      <h3>{t('search county')}:</h3>

      <input
        className="py-2 px-3"
        type="search"
        value={input}
        onChange={event => this.onInputChange(event)}
        onBlur={() => this.onBlur()}
        placeholder={t('Search')}
      />
      {open ? <div className="county-search-results">{counties.map(county => {
        return <div
          key={county.name}
          className="card card-hover text-center text-lg mx-2 mb-2"
          onClick={() => setDistrict(county.districtId)}
        >{county.name}</div>
      })}</div> : ''}
    </form>
  }
}

class Start extends Component {
  state = {
    stats: false,
  }

  componentDidMount() {
    fetch("/analytics/stats", {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: "GET",
    })
      .then(result => result.json())
      .then(stats => {
        this.setState({ stats })
      })
      .catch(console.error)
  }

  render() {
    const { language } = this.props
    const { stats } = this.state

    const statsAvailable = stats && stats.completedCount

    return <div className="py-8 bg-light">
      <div>
        <h2>Eduskuntavaalit 2023</h2>
        <p className="px-2">{t('info0')}</p>
        {/*<p className="px-2">{t('info1')}</p>*/}
        <p className="px-2"><a href={t('instructionsUrl')} target="_blank">{t('instructions')}</a></p>
        <p className="px-2"><a href={t('stationUrl')} target="_blank">{t('station')}</a></p>
      </div>

      <p className="px-2 font-bold text-sm text-center my-8 h-4">{statsAvailable ?
        language === 'fi'
          ? <span>Vaalikoneen on tehnyt {stats.completedCount.toLocaleString('fi')} kävijää. Vastaamiseen kului keskimäärin {stats.averageTime.toLocaleString('fi')} sekuntia.</span>
          : <span>{stats.completedCount.toLocaleString()} visitors completed the compass. Average answer time was {stats.averageTime.toLocaleString()} seconds.</span>
      : ''}</p>

      <h2 className="text-center">{t('begin')}:</h2>
      {districtNames.map(districtName => {
        return <div
          key={districtName}
          className="card card-hover text-center text-lg mx-2 mb-2"
          onClick={() => setDistrict(districts[districtName].id)}
        >
          {districtName}
        </div>
      })}

      <CountySearch />
    </div>
  }
}

export default Start